import {
  BlockquotePlugin,
  BoldPlugin,
  CodePlugin,
  CodeBlockPlugin,
  DEFAULTS_CODE_BLOCK,
  ExitBreakPlugin,
  HeadingPlugin,
  ItalicPlugin,
  KbdPlugin,
  LinkPlugin,
  ListPlugin,
  MentionPlugin,
  ParagraphPlugin,
  pipe,
  ResetBlockTypePlugin,
  SoftBreakPlugin,
  StrikethroughPlugin,
  withAutoformat,
  withInlineVoid,
  withLink,
  withList,
} from "@blfrg.xyz/slate-plugins";
import { SlatePlugin } from "@udecode/slate-plugins-core";
import { Editor } from "slate";
import { withHistory } from "slate-history";
import { ReactEditor, withReact } from "slate-react";
import { Options } from "./Options";

type SlateReactWithPlugin = <T extends Editor>(editor: T) => ReactEditor;

type PluginComponents = [SlatePlugin[], SlateReactWithPlugin];

export const createPlugins = (options: Options): PluginComponents => {
  const {
    paragraph,
    heading,
    mentions,
    blockquote,
    link,
    resetBlockType,
    softBreak,
    exitBreak,
    autoformat,
  } = options;

  const plugins = [
    ParagraphPlugin(paragraph),
    HeadingPlugin(heading),
    MentionPlugin(mentions),
    BoldPlugin(),
    ItalicPlugin(),
    CodePlugin(),
    CodeBlockPlugin(DEFAULTS_CODE_BLOCK),
    StrikethroughPlugin(),
    BlockquotePlugin(blockquote),
    ListPlugin(),
    LinkPlugin(link),
    KbdPlugin(),
    ResetBlockTypePlugin(resetBlockType),
    SoftBreakPlugin(softBreak),
    ExitBreakPlugin(exitBreak),
  ];

  const withPlugins = [
    withReact,
    withHistory,
    withLink(
      Object.assign({}, link, {
        rangeBeforeOptions: {
          multiPaths: false,
        },
      })
    ),

    withList(),
    withAutoformat(autoformat),
    withInlineVoid({ plugins }),
  ] as const;

  const withPlugin = (editor: Editor): ReactEditor => {
    return pipe(editor, ...withPlugins);
  };

  return [plugins, withPlugin];
};
